import { useI18n } from 'hooks/useI18n';
import { UIOfferRequirementsSection } from 'interfaces/ui/ui-offer-requirements-section';
import JobOfferLongText from '../JobOfferLongText';
import JobOfferSection from '../JobOfferSection';
import RequirementsEvolution from './RequirementsEvolution';
import RequirementsResponsabilities from './RequirementsResponsabilities';
import { StyledRequirementsSection } from './RequirementsSection.styled';

const RequirementsSection = (props: UIOfferRequirementsSection) => {
  const { t } = useI18n('job-offer');

  return (
    <JobOfferSection
      name="requisitos"
      sectionBg="alt"
      title={t('titles.requisites')}
    >
      <StyledRequirementsSection>
        <JobOfferLongText isMarkdown={props.migratedToMarkdown}>
          {props.requirementsIntro}
        </JobOfferLongText>

        {!props.isFreelance && (
          <RequirementsEvolution
            companyLogo={props.companyLogo}
            companyName={props.companyName}
            evolution={props.evolution}
            migratedToMarkdown={props.migratedToMarkdown}
          />
        )}

        {props.responsabilities?.length > 0 && (
          <RequirementsResponsabilities
            responsabilities={props.responsabilities}
            migratedToMarkdown={props.migratedToMarkdown}
          />
        )}
      </StyledRequirementsSection>
    </JobOfferSection>
  );
};

export default RequirementsSection;
